import { render } from "./VipRechargeLogsList.vue?vue&type=template&id=d83d94d0"
import script from "./VipRechargeLogsList.vue?vue&type=script&lang=js"
export * from "./VipRechargeLogsList.vue?vue&type=script&lang=js"

import "./VipRechargeLogsList.vue?vue&type=style&index=0&id=d83d94d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__